import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp } from '@ionic/vue';
import { onMounted } from 'vue';
import { VueIonicOutlet } from '@/ext/ionic/outlet/VueIonicOutlet';
import { useMetrica } from './composables/useMetrica';
import { RouteLocationNormalized, useRouter } from 'vue-router';
import { get } from 'lodash';
import { useAppCheckUpdate } from '@/composables/appCheckUpdate';
import { usePush, onNotification } from '@/composables/push';
import { useMessage } from './composables/messages';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { emitEvent } = useMetrica();
const router = useRouter();
const push = usePush();
const appUpdate = useAppCheckUpdate();
const { openMessage } = useMessage();

function getRouteInfoForMetric(route: RouteLocationNormalized) {
  const path = String(get(route.matched, '0.path', 'unknown'));
  const name: string = route.name ? String(route.name) : path;

  return {
    name,
    path,
    query: route.query,
  }
}

router.afterEach((to, from) => {
  const toInfo = getRouteInfoForMetric(to);
  const fromInfo = getRouteInfoForMetric(from);
  
  emitEvent('page/' + toInfo.name, {
    ...toInfo,
    prev: fromInfo,
  });
});

onMounted(async () => {
  // Проверка доступного обновления
  appUpdate.startCheck(); // async
  appUpdate.repeatChecking(6 * 60); // Запускаем проверку каждые 6 часов

  // Инициализация push
  const isSupported = await push.isSupported();
  if (isSupported) {
    // Запрос на получение пушей и авторегистрация токена
    await push.requestPermissionsAndRegister(false);
  }
});

onNotification(notification => {
  // actualizeUnreadDebounce(); // async

  openMessage({
    header: notification.title,
    message: notification.body,
    buttons: [],
  });
});

/**
 * Приложение инициализаровано и готово
 * работать с историей пушей и их отображением.
 */
 push.eventBus.emit('appInit');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(VueIonicOutlet), { ref: "outlet" }, null, 512)
    ]),
    _: 1
  }))
}
}

})